import { either, isEmpty } from 'ramda'

export const isWhitespace = (input) =>
    input?.length > 0 && input.replace(/\s/g, '').length === 0

export const isEmptyOrWhitespace = either(isEmpty, isWhitespace)
